/**
 * The Feedback_Page's route, in one place.
 *
 * `buildDeepLink` produces this shape and the router has to match it byte-for-byte, so both sides read
 * the pattern from here rather than each spelling it out.
 */
export const FEEDBACK_ROUTE_PATH = '/:clientId/:domainName/feedback/:ticketId';

/**
 * Whether a pathname is the Feedback_Page, used to suppress the navbar and sidebar.
 *
 * Exported rather than inlined in `TumblerHome` so the claim "this route renders chrome-less" is
 * testable without instantiating the whole app shell, and so a change to the route shape cannot update
 * the router while leaving the chrome predicate behind.
 *
 * Anchored and segment-counted on purpose: `/a/b/feedback` (no ticket) is **not** matched, because that
 * URL falls through to `DomainDetails` with `tab === 'feedback'` and keeps its chrome. A prefix match
 * here would strip the navbar off a page that still has navigation.
 */
const FEEDBACK_PATH_PATTERN = /^\/[^/]+\/[^/]+\/feedback\/[^/]+\/?$/;

export function isMerlinFeedbackPath(pathname: string): boolean {
  return FEEDBACK_PATH_PATTERN.test(pathname);
}
